'use strict';
import { UserBuilder } from '../users/user-builder';
var NoteBuilder = /** @class */ (function () {
    function NoteBuilder() {
        this.note = {
            id: 'b0bb0b0b-b0b0-b0b0-b0b0-b0bb0bb0bb0b',
            itemId: 'a0aa0a0a-a0a0-a0a0-a0a0-a0aa0aa0aa0a',
            text: 'This is a test note text. This is a test note text.  This is a test note text. ',
            lang: 'en',
            creationDate: 1442743132000,
            lastUpdateDate: 1442743132000,
            createdByUser: new UserBuilder().build()
        };
    }
    NoteBuilder.prototype.withId = function (noteId) {
        this.note.id = noteId;
        return this;
    };
    NoteBuilder.prototype.withText = function (text) {
        this.note.text = text;
        return this;
    };
    NoteBuilder.prototype.withUser = function (user) {
        this.note.createdByUser = user;
        return this;
    };
    NoteBuilder.prototype.withCreationDate = function (date) {
        this.note.creationDate = date;
        return this;
    };
    NoteBuilder.prototype.build = function () {
        return this.note;
    };
    return NoteBuilder;
}());
export { NoteBuilder };
//# sourceMappingURL=note-builder.js.map